// src/pages/landing/components/Footer.js
import React from 'react';
import './Footer.css';
import mood2moveLogo from '../../../assets/images/logo512.png';
import amsLogoWhite from '../../../assets/images/ams-logo-white.png';
import ubcLogoWhite from '../../../assets/images/ubc-logo-white.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const scrollToElement = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleFooterLinkClick = (e, targetId) => {
    e.preventDefault();
    scrollToElement(targetId);
  };

  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-content">

          {/* Logo Section */}
          <div className="footer-logo-section">
            <div className="footer-brand">
              <img src={mood2moveLogo} alt="Mood2Move Logo" className="footer-logo" />
              <span className="footer-brand-name">MOOD2MOVE</span>
            </div>
            <p className="footer-tagline">
              Revolutionizing student wellness through personalized movement solutions
            </p>
            <div className="footer-copyright-moved">
              <p>© {currentYear} MOOD2MOVE. All rights reserved.</p>
            </div>

            {/* ✅ NEW: Sponsor Lockup */}
            <div className="footer-sponsors">
              <span className="footer-sponsors-label">Supported by</span>
              <div className="footer-sponsors-logos">
                <img src={amsLogoWhite} alt="AMS of UBC" className="footer-sponsor-logo" />
                <div className="footer-sponsors-divider" />
                <img src={ubcLogoWhite} alt="University of British Columbia" className="footer-sponsor-logo" />
              </div>
            </div>
          </div>

          {/* Contact Section — unchanged */}
          <div className="footer-contact-section">
            <h4 className="footer-section-title">Contact Us</h4>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
                <a href="mailto:mood2move.contact@gmail.com" className="footer-contact-link">
                  mood2move.contact@gmail.com
                </a>
              </div>
              <div className="footer-contact-item">
                <FontAwesomeIcon icon={faInstagram} className="footer-icon" />
                <a
                  href="https://instagram.com/mood2move.app"
                  className="footer-contact-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  @mood2move
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links Section — unchanged */}
          <div className="footer-links-section">
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links-list">
              <li><a href="#features" className="footer-link"></a></li>
              <li><a href="#about" className="footer-link">About Us</a></li>
              <li><a href="#contact" className="footer-link">Contact</a></li>
              <li><a href="#privacy" className="footer-link">Privacy Policy</a></li>
            </ul>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;